import apiClient from './client'

export default {
  updateProfile(userData) {
    return apiClient.patch('/users/me', { user: userData })
  },

  updateProfileWithAvatar(formData) {
    return apiClient.patch('/users/me', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  removeAvatar() {
    return apiClient.delete('/users/me/avatar')
  },

  deleteAccount(usernameConfirmation) {
    return apiClient.delete('/users/me', {
      data: { username_confirmation: usernameConfirmation },
    })
  },

  getProfile(username) {
    return apiClient.get(`/users/${username}`)
  },

  getProfileTrails(username, params = {}) {
    return apiClient.get(`/users/${username}/trails`, { params })
  },

  getProfileComments(username, params = {}) {
    return apiClient.get(`/users/${username}/comments`, { params })
  },

  getProfileActivities(username, params = {}) {
    return apiClient.get(`/users/${username}/activities`, { params })
  },

  listDataExports() {
    return apiClient.get('/users/me/data_exports')
  },

  requestDataExport() {
    return apiClient.post('/users/me/data_exports')
  },
}
